import { FileNameMismatchViewModel } from 'documents/components/FileNameMismatchModal/FileNameMismatchViewModel'
import { WorkspaceClassification } from 'iam/models/Workspace'

export interface ClientNameInfo {
  firstName: string
  lastName: string
}

export function getFilesNotMatchingClientNames(
  jobWorkspaceClassification: WorkspaceClassification,
  filesToValidate: File[],
  clientNames: ClientNameInfo[],
) {
  if (filesToValidate.length < 1) {
    return []
  }

  // If the workspace is not B2C or B2B2C, we don't need to validate the file names.
  if (
    jobWorkspaceClassification !== WorkspaceClassification.B2C &&
    jobWorkspaceClassification !== WorkspaceClassification.B2B2C
  ) {
    return []
  }

  if (filesToValidate.length === 0) {
    return []
  }

  const fileNamesNotMatchingClients = Array.from(filesToValidate).filter(
    (file) => {
      const fileName = file.name.toLowerCase()
      const nameMatches = clientNames.some((client) => {
        const firstNameLower = client.firstName.toLowerCase()
        const lastNameLower = client.lastName.toLowerCase()
        const firstNameSubstr = firstNameLower.substring(
          0,
          Math.min(4, firstNameLower.length),
        )
        const lastNameSubstr = lastNameLower.substring(
          0,
          Math.min(4, lastNameLower.length),
        )

        return (
          fileName.includes(firstNameSubstr) ||
          fileName.includes(lastNameSubstr)
        )
      })

      return !nameMatches
    },
  )

  return fileNamesNotMatchingClients
}

export function validateFileNamesAgainstClients(
  jobWorkspaceClassification: WorkspaceClassification,
  filesToValidate: File[],
  clientNames: ClientNameInfo[],
  confirmFileNameMismatch: FileNameMismatchViewModel,
) {
  const fileNamesNotMatchingClients = getFilesNotMatchingClientNames(
    jobWorkspaceClassification,
    filesToValidate,
    clientNames,
  )

  if (fileNamesNotMatchingClients.length === 0) {
    return
  }

  confirmFileNameMismatch.open(clientNames, fileNamesNotMatchingClients)
}
